import { ToggleButton, ToggleButtonGroup, styled } from "@mui/material"

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    minHeight: 48,
    padding: 3,
    backgroundColor: theme.palette.input.background.white05,
    border: `1px solid ${theme.palette.input.borderColor.primary}`,
    borderRadius: 0,

    "& .MuiToggleButtonGroup-grouped": {
        margin: 0,
        border: 0,
        borderRadius: 0,

        "&:not(:first-of-type)": {
            borderRadius: 0,
        },

        "&:first-of-type": {
            borderRadius: 0,
        },
    },
}))

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    minHeight: 32,
    padding: "6px 16px",
    color: theme.palette.primary.white70,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSizes.sm,
    fontWeight: theme.typography.fontWeights.regular,
    lineHeight: "20px",
    textTransform: "none",
    whiteSpace: "nowrap",

    "&:hover": {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.input.background.white30,
    },

    "&.Mui-selected": {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main2,
        fontWeight: theme.typography.fontWeights.bold,

        "&:hover": {
            backgroundColor: theme.palette.primary.main3,
        },
    },

    "&.Mui-focusVisible": {
        outline: `2px solid ${theme.palette.common.white}`,
        outlineOffset: -2,
    },

    "&.Mui-disabled": {
        color: theme.palette.text.disabled,
        opacity: 0.4,
    },
}))
